import script from "./customerPoint.vue?vue&type=script&setup=true&lang=js"
export * from "./customerPoint.vue?vue&type=script&setup=true&lang=js"

import "./customerPoint.vue?vue&type=style&index=0&id=36acaf8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36acaf8a"]])

export default __exports__